(function (Drupal, $) {
  'use strict';

  function videoSetup() {
    const poster = $('.poster')

    poster.off('click').on('click', function (event) {
      const $this = $(event.target)

      $this.closest('.vcontainer').addClass('clicked')
    })
  }

  Drupal.behaviors.video = {
    attach: function (context, settings) {
      videoSetup()
    }
  }

})(Drupal, jQuery)
